// Mock data service - In production, replace with real API calls
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

// Simulated trending data
const generateMockTrends = (count = 20) => {
  const topics = [
    'AI Revolution', 'Climate Change', 'Space Exploration', 'Cryptocurrency',
    'Electric Vehicles', 'Quantum Computing', 'Mental Health', 'Remote Work',
    'Web3', 'Metaverse', 'Gaming', 'Fitness', 'Sustainability', 'Education Tech',
    'Healthcare Innovation', 'Renewable Energy', 'Social Media', 'Cybersecurity',
    'Blockchain', 'Machine Learning', '5G Technology', 'Virtual Reality',
    'Augmented Reality', 'Artificial Intelligence', 'Data Privacy'
  ];

  const categories = ['Technology', 'Politics', 'Sports', 'Entertainment', 'Business'];
  const regions = ['Global', 'North America', 'Europe', 'Asia', 'South America', 'Africa'];

  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    topic: topics[Math.floor(Math.random() * topics.length)],
    mentions: Math.floor(Math.random() * 100000) + 1000,
    growth: (Math.random() * 200 - 50).toFixed(1),
    category: categories[Math.floor(Math.random() * categories.length)],
    region: regions[Math.floor(Math.random() * regions.length)],
    sentiment: (Math.random() * 2 - 1).toFixed(2),
    timestamp: new Date(Date.now() - Math.random() * 86400000).toISOString(),
    source: ['Twitter', 'Reddit', 'Google Trends'][Math.floor(Math.random() * 3)],
  }));
};

// Generate time series data
const generateTimeSeriesData = (days = 7) => {
  const data = [];
  const now = new Date();
  
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    
    data.push({
      date: date.toISOString().split('T')[0],
      mentions: Math.floor(Math.random() * 50000) + 10000,
      engagement: Math.floor(Math.random() * 100000) + 20000,
      sentiment: (Math.random() * 2 - 1).toFixed(2),
    });
  }
  
  return data;
};

// Generate heatmap data
const generateHeatmapData = () => {
  const regions = [
    'North America', 'South America', 'Europe', 'Africa', 
    'Middle East', 'Asia', 'Oceania'
  ];
  
  return regions.map(region => ({
    region,
    value: Math.floor(Math.random() * 100000),
    trends: generateMockTrends(5),
  }));
};

export const trendingService = {
  // Get trending topics
  getTrends: async (params = {}) => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    let trends = generateMockTrends(50);
    
    // Apply filters
    if (params.category && params.category !== 'all') {
      trends = trends.filter(t => t.category.toLowerCase() === params.category.toLowerCase());
    }
    
    if (params.region && params.region !== 'all') {
      trends = trends.filter(t => t.region.toLowerCase() === params.region.toLowerCase());
    }
    
    if (params.source && params.source !== 'all') {
      trends = trends.filter(t => t.source.toLowerCase() === params.source.toLowerCase());
    }
    
    // Sort by mentions
    trends.sort((a, b) => b.mentions - a.mentions);
    
    return {
      data: trends.slice(0, params.limit || 20),
      total: trends.length,
    };
  },

  // Get trend details
  getTrendDetails: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const trend = generateMockTrends(1)[0];
    trend.id = id;
    trend.timeSeriesData = generateTimeSeriesData();
    trend.relatedTopics = generateMockTrends(5);
    
    return trend;
  },

  // Get time series data
  getTimeSeriesData: async (topicId, days = 7) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return generateTimeSeriesData(days);
  },

  // Get heatmap data
  getHeatmapData: async () => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return generateHeatmapData();
  },

  // Get analytics summary
  getAnalyticsSummary: async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    return {
      totalTrends: 1247,
      activeTrends: 328,
      totalMentions: 15482930,
      avgSentiment: 0.42,
      topCategories: [
        { name: 'Technology', count: 423 },
        { name: 'Politics', count: 312 },
        { name: 'Sports', count: 245 },
        { name: 'Entertainment', count: 198 },
        { name: 'Business', count: 167 },
      ],
      topRegions: [
        { name: 'North America', count: 502 },
        { name: 'Europe', count: 398 },
        { name: 'Asia', count: 287 },
        { name: 'South America', count: 124 },
        { name: 'Africa', count: 89 },
      ],
    };
  },

  // Search trends
  searchTrends: async (query) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const allTrends = generateMockTrends(100);
    const results = allTrends.filter(t => 
      t.topic.toLowerCase().includes(query.toLowerCase())
    );
    
    return results.slice(0, 20);
  },
};